import { PasswordInputValidation, UserInputValidation, isEmailValid } from "../../common/utilities/validations";

/** Hook validador de inputs */
const useInputValidator = () => {
  const validateInput = ((objectToValidate, applyData) => {
    /** Si el texto no es vacio entonces validara */
    if (objectToValidate.text !== "") {
      const data = objectToValidate.isPassword ? PasswordInputValidation(objectToValidate.text) : UserInputValidation(objectToValidate.text);
      applyData(data);
    }
  });
  /** Retornara el mensaje de validacion */
  return { validateInput };
};

export const useInputValidatorEmails = () => {
  const validateInputEmail = ((objectToValidate, applyData) => {
    /** Si el texto no es vacio entonces validara */
    if (objectToValidate.text !== "") {
      const data = isEmailValid(objectToValidate.text);
      applyData(data);
    }
  });

  /** Retornara el mensaje de validacion */
  return { validateInputEmail };
};

export default useInputValidator;